import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getApiBaseUrl } from '../utils/axios';
import PageMeta from './PageMeta';
import './Blog.css';

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!slug) return;
    setLoading(true);
    setError(false);
    fetch(`${getApiBaseUrl()}/api/blog/${slug}`)
      .then(res => {
        if (!res.ok) throw new Error('Not found');
        return res.json();
      })
      .then(data => setPost(data))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return (
      <div className="blog-layout">
        <header className="blog-header">
          <div className="blog-header-inner">
            <Link to="/welkom" className="blog-logo-link">
              <img src="/logo-offerterunner.png" alt="OfferteRunner" className="blog-logo" />
            </Link>
            <nav className="blog-nav">
              <Link to="/welkom">Home</Link>
              <Link to="/blog">Blog</Link>
            </nav>
          </div>
        </header>
        <main className="blog-main">
          <div className="blog-container"><p className="blog-loading">Laden...</p></div>
        </main>
      </div>
    );
  }

  if (error || !post) {
    return (
      <div className="blog-layout">
        <header className="blog-header">
          <div className="blog-header-inner">
            <Link to="/welkom" className="blog-logo-link">
              <img src="/logo-offerterunner.png" alt="OfferteRunner" className="blog-logo" />
            </Link>
            <nav className="blog-nav">
              <Link to="/welkom">Home</Link>
              <Link to="/blog">Blog</Link>
            </nav>
          </div>
        </header>
        <main className="blog-main">
          <div className="blog-container">
            <h1>Artikel niet gevonden</h1>
            <p><Link to="/blog">Terug naar Blogpagina</Link></p>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="blog-layout">
      <PageMeta title={post.title} description={post.metaDescription || post.title} />
      <header className="blog-header">
        <div className="blog-header-inner">
          <Link to="/welkom" className="blog-logo-link">
            <img src="/logo-offerterunner.png" alt="OfferteRunner" className="blog-logo" />
          </Link>
          <nav className="blog-nav">
            <Link to="/welkom">Home</Link>
            <Link to="/blog">Blog</Link>
            <Link to="/welkom#pricing">Prijzen</Link>
            <a href="mailto:support@ploko.nl">Contact</a>
          </nav>
        </div>
      </header>

      <article className="blog-main">
        <div className="blog-container blog-post-container">
          {post.cover_image_url && (
            <div className="blog-post-cover">
              <img
                src={post.cover_image_url.startsWith('http') ? post.cover_image_url : `${getApiBaseUrl()}${post.cover_image_url}`}
                alt=""
              />
            </div>
          )}
          <time className="blog-post-date" dateTime={post.date}>
            {new Date(post.date).toLocaleDateString('nl-NL', { day: 'numeric', month: 'long', year: 'numeric' })}
          </time>
          <h1 className="blog-post-title">{post.title}</h1>
          <div
            className="blog-post-body"
            dangerouslySetInnerHTML={{ __html: (post.body || '').replace(/<h1[^>]*>[\s\S]*?<\/h1>\s*/i, '') }}
          />
          <p className="blog-post-back">
            <Link to="/blog">← Terug naar Blogpagina</Link>
          </p>
        </div>
      </article>

      <footer className="blog-footer">
        <div className="blog-container">
          <p>
            <Link to="/welkom">OfferteRunner</Link> – Professionele offertes in minuten. Koppeling met Odoo en AI.
          </p>
        </div>
      </footer>
    </div>
  );
}
